import { FC } from 'react';
// component
import CommonSweetenerAndFlavorRadioGroup from 'components/common/CommonSweetenerAndFlavorRadioGroup';

const Effervescent: FC = () => <CommonSweetenerAndFlavorRadioGroup />;

export default Effervescent;
